import {
  Required,
  DataValidator,
  transformKeys,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface MaterialTagUpdateResponse {
  create_time: number,
  folder_id: number,
  id: number,
  tag_name: string,
  update_mid_tag_err_ids: number[],
  update_time: number
};

class MaterialTagUpdateData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Tag name cannot be empty")
  @IsString("Tag name must be a string")
  tagName: string;
}

const transformAndValidateData = (
  response: MaterialTagUpdateResponse
): MaterialTagUpdateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, MaterialTagUpdateData);
  } catch (error) {
    console.error("Material tag update data validation failed:", error.message);
    throw error;
  }
};

/** 素材标签更新 */
export const materialTagUpdate = async ({
  id,
  folderId,
  tagName
}: {
  id: number,
  folderId: number,
  tagName: string
}) => {
  const res = await api.post<MaterialTagUpdateResponse>('/material_tag/update', {
    id: id,
    folder_id: folderId,
    tag_name: tagName,
  });
  const data = transformAndValidateData(res.data);
  return data;
}